import { createReducer, on } from '@ngrx/store';
import { UserState, setUser, updateUser } from './user.actions';
import { User } from '../../interfaces/interfaces.interface';

export const initialState: UserState = {
  data: null,
  loading: false,
};

export const userReducer = createReducer(
  initialState,
  on(setUser, (state, payload) =>  ({ ...state, ...payload, loading:true }) ),
  on(updateUser, (state, payload) => ({ ...state, ...payload })),
);